module.exports = __webpack_public_path__ + "static/media/59.e82b8b90.png";